<template>
  <div class="flex custom-auth-page">
    <template v-if="isDesktop">
      <span class="title-video"></span>
      <div class="video-back"></div>
      <div class="w-full h-100 video-container">
        <video autoplay muted loop>
          <source src="@/assets/video/video_safras.mp4" type="video/mp4" />
        </video>
      </div>
    </template>
    <div class="flex vx-row items-center justify-center bg-auth"
      :class="{'w-full no-gutter': !isDesktop, 'h-screen': !fromPopup}"
      id="page-login"
      >
      <vs-popup :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPopupPrivacyPolicy" class="privacy-policy-modal" :class="{'privacy-policy-modal-mobile': !isDesktop}">
        <privacy-policy v-if="displayPopupPrivacyPolicy"></privacy-policy>
      </vs-popup>
      <vs-popup
        :title="$t('TERMS_USE').Title"
        :active.sync="displayPopupTermsCondition"
        class="terms-condition-modal"
        :class="{'terms-condition-modal-mobile': !isDesktop}"
      >
        <terms-use v-if="displayPopupTermsCondition" :displayActionButton="true" @accept-terms='onAcceptTermsCondition' @cancel="onCancelTermsCondition"></terms-use>
      </vs-popup>
      <!-- <div class="mobile-btn-back btnback">
        <button v-if="!isDesktop" @click="onClose(false)" class="btn-close"><feather-icon icon='XIcon'/></button>
      </div> -->
      <!-- START PAGE -->
      <div class="h-full w-full">
        <VuePerfectScrollbar
          class="auth-content-scroll h-full"
          :settings="settings"
          :suppressScrollX="true"
        >
        <div class="w-full login-cont" :class="{'items-center': isDesktop}">
          <div slot="no-body" class="full-page-bg-color" :class="{'oversize': !isDesktop, 'h-full': displayConfirmEmail}">
            <div class="login-body h-full">
              <div class="vx-col  lg:block lg:w-1/1 logo-click" @click="onClose(false)">
              <span class="back-login-button" v-if="!fromPopup">
                  <feather-icon icon="XIcon" svgClasses="w-6 h-6" />
                </span>
                <vx-tooltip :text="$t('LOGIN').Click_Back" position="bottom" delay=".1s">
                  <div class="logo-login mx-auto" :class="{'logo-login-mobile': !isDesktop}"></div>
                </vx-tooltip>
            </div>
              <div class="w-full center" v-if="!displayConfirmEmail">
                <h3 class="mb-1">{{$t('REGISTER').Title}}</h3>
              </div>
              <div class="pagecard pt-0">
                <p class="mb-5" v-if="!displayConfirmEmail">{{$t('REGISTER').Subtitle}}</p>
                <div class="login-tabs-container content-login" v-if="!displayConfirmEmail">

                  <div class="clearfix mt-3">

                    <ul class="centerx mt-2 type-register">
                      <li>
                        <vs-radio v-model="form.sendDemo" :vs-value="false" class="mt-1" vs-name="demo-account">{{$t('REGISTER').Request_Free}}</vs-radio>
                      </li>
                      <li v-if="!canDisplayOnMobileIOS">
                        <vs-radio v-model="form.sendDemo" :vs-value="true" class="mt-5" vs-name="demo-account">{{$t('REGISTER').Request_Demo}}</vs-radio>
                      </li>
                    </ul>
                    <!-- temporarily commented out until implementation -->
                    <ul class="centerx">
                      <li class="mb-3">
                        <vs-radio v-model="form.userType" :vs-value="userTypePf.id" class="mr-4" vs-name="layout-type-vertical">{{userTypePf.name}}</vs-radio>
                        <vs-radio  v-model="form.userType" :vs-value="userTypePj.id" class="mr-4" vs-name="layout-type-vertical">{{userTypePj.name}}</vs-radio>
                      </li>
                    </ul>
                    <!-- <label for="">{{$t('REGISTER').Field_UserType}}</label> -->
                    <!-- <v-select
                      name="userType"
                      label="name"
                      v-model="form.userType"
                      :options="userTypes"
                      :reduce="userTypes => userTypes.id"
                    /> -->
                    <!-- <span class="text-danger text-sm">{{ errors.first('userType') }}</span> -->
                    <span class="text-danger text-sm" v-show="this.showErrors && errors.has('userType')">{{ errors.first('userType') }}</span>

                    <!-- <label for="cpf" v-if="selectedUserTypePF">{{$t('REGISTER').Field_Cpf}}</label> -->
                    <template v-if="selectedUserTypePF">
                      <vs-input
                        v-validate="'required'"
                        data-vv-validate-on="blur"
                        name="cpf"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        :label="$t('REGISTER').Field_Cpf"
                        :placeholder="$t('REGISTER').Field_Cpf"
                        v-model="form.cpf"
                        class="w-full mt-2"
                        autocomplete="off"
                        key="cpf"
                        v-mask="'###.###.###-##'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</span>
                    </template>


                    <!-- <label for="cnpj" v-if="selectedUserTypePJ">{{$t('REGISTER').Field_Cnpj}}</label> -->
                    <template v-if="selectedUserTypePJ">
                      <vs-input
                        v-validate="'required'"
                        data-vv-validate-on="blur"
                        name="cnpj"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        :label="$t('REGISTER').Field_Cnpj"
                        :placeholder="$t('REGISTER').Field_Cnpj"
                        v-model="form.cnpj"
                        class="w-full register-input mt-2"
                        autocomplete="off"
                        key="cnpj"
                        v-mask="'##.###.###/####-##'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('cnpj')">{{ errors.first('cnpj') }}</span>
                    </template>

                    <!-- <label for="phone" class="">{{$t('REGISTER').Field_Phone}}</label> -->
                    <!-- <cleave
                      v-validate="'required'"
                      id="phone"
                      name="phone"
                      v-model="form.phone"
                      class="form-control vs-inputx vs-input--input normal"
                      :options="maskOptions.cellphone"
                      :placeholder="$t('REGISTER').Placeholder_Phone"
                    /> -->
                    <!-- <span class="text-danger text-sm">{{ errors.first('phone') }}</span> -->
                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="$t('NEW_CLIENT').Phone_field"
                      icon-no-border
                      icon="icon icon-phone"
                      icon-pack="feather"
                      :label="$t('REGISTER').Field_Phone"
                      :placeholder="$t('REGISTER').Field_Phone"
                      v-model="form.phone"
                      class="w-full mt-2"
                      autocomplete="off"
                      v-mask="'## #####-####'"
                    />
                    <span class="text-danger text-sm" v-show="errors.has($t('NEW_CLIENT').Phone_field)">{{ errors.first($t('NEW_CLIENT').Phone_field) }}</span>

                    <vs-input
                      v-validate="'required|min:3'"
                      data-vv-validate-on="blur"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label="$t('REGISTER').Field_Username"
                      :name="$t('REGISTER').Field_Username"
                      :placeholder="$t('REGISTER').Placeholder_Username"
                      v-model="form.username"
                      class="w-full mt-2"
                      autocomplete="off"
                    />
                    <!-- <span class="text-danger text-sm">{{ errors.first('displayName') }}</span> -->
                    <span class="text-danger text-sm" v-show="errors.has($t('REGISTER').Field_Username)">{{ errors.first($t('REGISTER').Field_Username) }}</span>

                    <vs-input
                      ref="e-mail"
                      v-validate="'required|email'"
                      data-vv-validate-on="blur"
                      name="e-mail"
                      type="email"
                      icon-no-border
                      icon="icon icon-mail"
                      icon-pack="feather"
                      :label="$t('REGISTER').Field_Email"
                      :placeholder="$t('REGISTER').Placeholder_Email"
                      v-model="form.email"
                      class="w-full mt-2"
                      autocomplete="new-email"
                      @copy="preventCopy"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('e-mail')">{{ errors.first('e-mail') }}</span>

                    <vs-input
                      v-validate="'required|email|confirmed:e-mail'"
                      data-vv-validate-on="blur"
                      data-vv-as="e-mail"
                      name="repetir email"
                      type="email"
                      icon-no-border
                      icon="icon icon-mail"
                      icon-pack="feather"
                      :label="$t('REGISTER').Field_Email_Again"
                      :placeholder="$t('REGISTER').Placeholder_Email_Again"
                      v-model="form.emailAgain"
                      class="w-full mt-2"
                      autocomplete="new-email-again"
                      @paste="preventPaste"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('repetir email')">{{ errors.first('repetir email') }}</span>

                    <vs-input
                      ref="password"
                      type="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6|max:10'"
                      :name="$t('LOGIN').Password"
                      :label="$t('REGISTER').Field_Password"
                      :placeholder="$t('REGISTER').Placeholder_Password"
                      v-model="form.password"
                      class="w-full mt-2"
                      autocomplete="new-password"
                    />
                    <!-- <span class="text-danger text-sm">{{ errors.first('password') }}</span> -->
                    <span class="text-danger text-sm"
                          v-show="errors.has($t('LOGIN').Password)">{{ errors.first($t('LOGIN').Password) }}</span>

                    <!-- <vs-input
                      type="password"
                      v-validate="'min:6|max:10|confirmed:password'"
                      data-vv-validate-on="blur"
                      data-vv-as="password"
                      name="confirm_password"
                      label-placeholder="Confirm Password"
                      placeholder="Confirm Password"
                      v-model="confirm_password"
                      class="w-full mt-6"
                    />
                    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span> -->
                    <!-- <div class="mt-5 mb-5 right green-safra">
                      <vs-checkbox class="mt-5 mb-5" vs-name="terms-of-use" @click.prevent="openTermsCondition"></vs-checkbox>
                      <a href="" @click.prevent="openTermsCondition" class="forgot-pass cursor-pointer">{{$t('REGISTER').Terms_Of_Use}}</a>
                      <feather-icon v-if="isTermsConditionAccepted" icon='CheckCircleIcon' svgClasses='h-4 w-4' class='ml-2' />
                    </div> -->

                    <div style="display: flex; flex-direction: row; align-items: center;">
                      <vs-checkbox
                        v-model="isTermsConditionAccepted"
                        class="mt-5 mb-5 right"
                        @click.stop="openTermsCondition"
                      >
                    </vs-checkbox>
                    <a @click.stop="openTermsCondition" class="forgot-pass cursor-pointer">{{$t('REGISTER').Accept_Terms}}</a>
                    </div>
                    <!-- <vs-button type="border" @click="openLogin" class="mt-6">Login</vs-button> -->
                    <!-- <vs-button type="border" to="/pages/login" class="mt-6">Login</vs-button> -->
                    <div class="flex flex-row-reverse">
                      <vs-button
                        class="btn-login"
                        @click="onRegister"
                        :disabled="errors.all().length > 0"
                      >{{$t('REGISTER').Register}}</vs-button>
                        <!-- :disabled="!validateForm && errors.all().length > 0" -->
                    </div>
                    <auth-links :fromPopup="fromPopup" :login="true" :forgotPass="false" :lostAccess="true" @open-login="$emit('open-login')" @open-lost-access="$emit('open-lost-access')"></auth-links>
                  </div>
                </div>
                <div class="p-8 login-tabs-container content-login confirm-email" v-if="displayConfirmEmail">
                  <!-- <vs-button class="btn-back-two-auth" type="flat" @click="displayConfirmEmail=!displayConfirmEmail">Voltar</vs-button> -->
                  <div class="mb-6">
                    <h4 class="mb-4 title-box-login">{{$t('REGISTER').Confirm_Email_Title}}</h4>
                    <p>{{$t('LOGIN').Confirm_Email_Desc}}</p>
                    <p>{{$t('LOGIN').Confirm_Email_Desc_Token_Val}}</p>
                    
                    <span>{{$t('REGISTER').Confirm_Email_Subtitle}}</span>
                    <p style="font-size: smaller"><a style="text-decoration: underline;" class="cursor-pointer" @click.stop="sendTokenConfirmEmail">{{ $t('LOGIN').Click_Here }}</a> {{ $t('LOGIN').Resend_Token }}</p>
                  </div>
                  <vs-input
                      :name="$t('REGISTER').Confirm_Email_Field_Code"
                      id="emailToken"
                      v-validate="'required'"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Código"
                      v-model="emailToken"
                      class="w-full"
                      autocomplete="off"
                    />
                    <span class="text-danger text-sm" v-show="errors.has($t('REGISTER').Confirm_Email_Field_Code)">{{ errors.first($t('REGISTER').Confirm_Email_Field_Code) }}</span>

                    <div class="flex mt-5">
                      <vs-button @click="validateToken" class="btn-login">{{$t('BUTTONS').Enter}}</vs-button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </VuePerfectScrollbar>
      </div>
      <div v-if="recaptchaEnabled">
        <vue-recaptcha ref="invisibleRecaptchaRegister" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" size="invisible" :sitekey="recaptchaKey" />
      </div>
      <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="backRegister"></div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import messagesNotifyHelper from '../../helpers/messages-notify-helper';
import authService from '../../providers/authService';
import formatFieldHelper from '../../helpers/format-field-helper';
import PrivacyPolicy from './help/PrivacyPolicy.vue'
import TermsUse from './help/TermsUse.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AppConstants from '../../appConstants';
import AuthFooterPrivacy from './AuthFooterPrivacy.vue';
import VueRecaptcha from 'vue-recaptcha';
import AuthLinks from './AuthLinks.vue';
import Typewriter from 't-writer.js'
import messageDialogHelper from '../../helpers/message-dialog-helper';
import router from "@/router";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";

export default {
  props: {
    fromPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showErrors: false,
      displayConfirmEmail: false,
      emailToken: '',
      recaptchaVerified: false,
      form: {
        username: '',
        email: '',
        emailAgain: '',
        password: '',
        userType: 1,
        cnpj: '',
        cpf: '',
        phone: '',
        sendDemo: false
      },
      isTermsConditionAccepted: false,
      userTypePf: { id: 1, name: this.$t('REGISTER').UserType_Item_PF},
      userTypePj: { id: 2, name: this.$t('REGISTER').UserType_Item_PJ},
      userTypes: [
        { id: 1, name: this.$t('REGISTER').UserType_Item_PF},
        { id: 2, name: this.$t('REGISTER').UserType_Item_PJ},
      ],
      maskOptions: {
        phone: {
          phone: true,
          phoneRegionCode: 'BR'
        },
        cellphone: {
          blocks: [2, 5, 4],
          delimiters: [' ', '-']
        },
        cpf: {
          blocks: [3, 3, 3, 2],
          delimiters: ['.', '.', '-']
        },
        cnpj: {
          blocks: [2, 3, 3, 4, 2],
          delimiters: ['.', '.', '/', '-']
        }
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      displayPopupPrivacyPolicy: false,
      displayPopupTermsCondition: false,
      disableButtonTermsCondition: false,
    };
  },
  watch: {
    "form.userType"(val) {
      this.form.cnpj = "";
      this.form.cpf = "";
    }
  },
  computed: {
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
    recaptchaEnabled() {
      return this.$config.mobile_recaptcha_enabled;
    },
    recaptchaKey() {
      if (this.isDesktop) {
        return this.$config.desktop_recaptcha_key;
      } else {
        return this.$config.mobile_recaptcha_key;
      }
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.form.username != "" &&
        this.form.email != "" &&
        this.form.emailAgain != "" &&
        // this.form.userType != "" &&
        this.form.phone != "" &&
        ((this.form.userType == 1 && this.form.cpf != "") || (this.form.userType == 2 && this.form.cnpj != "")) &&
        this.form.password != "" &&
        // this.confirm_password != "" &&
        this.isTermsConditionAccepted === true
      );
    },
    selectedUserTypePF() {
      return this.form.userType == 1;
    },
    selectedUserTypePJ() {
      return this.form.userType == 2;
    },
  },
  mounted() {
    if (this.isDesktop) {
      const target = document.querySelector('.title-video')
      // console.log(target);
      const options = {
        loop: true,
        typeColor: 'white',
        typeSpeed: 80,
        deleteSpeed: 10,
      }

      const writer = new Typewriter(target, options)
        .changeCursorColor('white')
        .type('Safras & Mercado: A sua casa de análises do Brasil e América Latina')
        .rest(30000000)
        .clear()
        .start();
    }
  },
  created() {
  },
  methods: {
    preventCopy(event) {
      event.preventDefault();
    },
    preventPaste(event) {
      event.preventDefault();
    },
    backRegister() {
      this.$emit('closeRegister');
    },
    onExpiredRecaptcha() {
      console.log('Expired');
      this.recaptchaVerified = false;
    },
    onVerifyRecaptcha() {
      // console.log('Verify: ' + response);
      this.recaptchaVerified = true;
      this.onSendRegister();
    },
    openTermsCondition() {
      this.displayPopupTermsCondition = true;
      // this.isTermsConditionAccepted = false;
    },
    onAcceptTermsCondition() {
      this.isTermsConditionAccepted = true;
      this.displayPopupTermsCondition = false;
      this.$forceUpdate();
    },
    onCancelTermsCondition() {
      this.isTermsConditionAccepted = false;
      this.displayPopupTermsCondition = false;
    },
    scrollHandleToEnd() {
      // console.log('scrollHandleToEnd')
      this.disableButtonTermsCondition = true;
    },
    sendTokenConfirmEmail() {
      authService
        .sendConfirmEmailToken(this.email, new URLSearchParams())
        .then(() => {
          messagesNotifyHelper.successNotify(this.$t('REGISTER').Confirm_Email_Title, this.$t('REGISTER').Confirm_Email_Send_Token);
          this.emailToken = '';
        })
        .catch(error => {
          console.log(error);
        });
    },
    validateToken() {
      const form = {
        email: this.form.email,
        token: this.emailToken ? this.emailToken.toLowerCase() : this.emailToken
      }
      const deviceId = localStorage.getItem('deviceId');
      if (deviceId) {
        form.device_id = deviceId;
      }
      authService
        .validateConfirmEmailToken(form, new URLSearchParams())
        .then(response => {
          authService.successLogin(response, false);
          const routeQuery = Object.keys(this.$route.query).filter(q => q != 'to');
          const routePath = {
            path: this.$route.query.to ? this.$route.query.to : "/"
          };

          if (routeQuery) {
            routePath.query = {};
            routeQuery.forEach(key => {
              routePath.query[key] = this.$route.query[key];
            });
          }

          this.$router.push(routePath);
          this.onClose(true);
        })
        .catch(error => {
          console.log(error);
        });
    },
    onClose(reloadPage = false) {
      if (reloadPage) {
        window.location.reload();
      }
      if (this.fromPopup) {
        this.$emit('close');
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    openLogin() {
      router.push({ path:  checkDeviceTypeHelper.getUrlLogin()});
    },
    onRegister() {
      if (!this.isTermsConditionAccepted) {
        messagesNotifyHelper.errorNotify((this.$t('LOGIN').Notify_Error_Title), this.$t('LOGIN').Notify_Accept_Terms);
        return;
      }
      this.showErrors = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.recaptchaEnabled) {
            if (this.recaptchaVerified) {
                this.onSendRegister();
            } else {
              this.$refs.invisibleRecaptchaRegister.execute();
            }
          } else {
            this.onSendRegister();
          }
        } else {
            messagesNotifyHelper.errorNotify((this.$t('LOGIN').Notify_Error_Title), this.$t('LOGIN').Notify_Error_Message);
          }
      })

    },
    onSendRegister() {
       const sendForm = {
          name: this.form.username,
          email: this.form.email,
          emailAgain: this.form.emailAgain,
          userType: this.form.userType,
          password: this.form.password,
          phone: formatFieldHelper.unmaskField(this.form.phone),
          sendDemo: this.form.sendDemo
        };
        if (this.form.cpf) {
          sendForm['cnpj_cpf'] = formatFieldHelper.unmaskField(this.form.cpf);
        }
        if (this.form.cnpj) {
          sendForm['cnpj_cpf'] = formatFieldHelper.unmaskField(this.form.cnpj);
        }
        const deviceId = localStorage.getItem('deviceId');
        if (deviceId) {
          sendForm.device_id = deviceId;
        }
        authService.register(sendForm, new URLSearchParams())
        .then(() => {
          this.form.username = '';
          this.form.phone = '';
          this.form.emailAgain = '';
          this.form.password = '';
          this.form.cpf = '';
          this.form.cnpj = '';
          this.form.userType = 1;
          this.showErrors = false;
          this.displayConfirmEmail = true;
          messagesNotifyHelper.successNotify(this.$t('REGISTER').Success_Register);
          if (this.form.sendDemo) {
            messageDialogHelper.displayDialogAccept(
              this.$t('TOAST_NOTIFICATIONS').registerRequestDemoTitle,
              this.$t('TOAST_NOTIFICATIONS').registerRequestDemoMessage,
              () => {})
          }
        })
        .catch(error => {
          console.log(error);
        });


    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },

  },
  components: {
    vSelect,
    PrivacyPolicy,
    TermsUse,
    VuePerfectScrollbar,
    AuthFooterPrivacy,
    VueRecaptcha,
    AuthLinks
  }
};

</script>




